import clsx from "clsx";

const LoadingText = ({ className }) => {
  return (
    <div className={clsx(className, "loading-text")}>
      <span></span>
    </div>
  );
};

export default LoadingText;
